import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, authHeaders } from "@/lib/api";

export const TranscriptDialog = ({ leadId, onClose, onError }) => {
  const [lead, setLead] = useState(null);

  useEffect(() => {
    if (!leadId) { setLead(null); return; }
    api.get(`/admin/leads/${leadId}`, { headers: authHeaders() }).then((r) => setLead(r.data)).catch(onError);
  }, [leadId, onError]);

  return (
    <Dialog open={!!leadId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="transcript-dialog" className="max-h-[85vh] max-w-xl overflow-hidden border-slate-200 bg-cream-100 text-navy-900 flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{lead ? `${lead.name} · ${lead.mobile}` : "Chat Transcript"}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 space-y-3 overflow-y-auto pr-1" data-testid="transcript-messages">
          {!lead && <Loader2 className="mx-auto my-10 h-6 w-6 animate-spin text-slate-500" />}
          {lead?.transcript.length === 0 && <p className="text-slate-500">No transcript</p>}
          {lead?.transcript.map((m, i) => m.role === "system" ? (
            <p key={i} data-testid={`transcript-system-note-${i}`} className="text-center text-sm italic text-amber-700">{m.text}</p>
          ) : (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] whitespace-pre-line rounded-2xl px-4 py-2.5 text-[15px] ${m.role === "user" ? "bg-gold text-navy-950" : "border border-slate-200 bg-slate-100 text-slate-800"}`}>
                {m.text}
                <div className={`mt-1 text-[11px] ${m.role === "user" ? "text-navy-900/70" : "text-slate-500"}`}>{new Date(m.ts).toLocaleString("en-IN")}</div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
